import { Controller } from "@hotwired/stimulus"

const MET_CLASS = "text-content-success"
const UNMET_CLASS = "text-content-muted"
const MET_ICON_CLASSES = ["fas", "fa-circle-check"]
const UNMET_ICON_CLASSES = ["far", "fa-circle"]
const ICON_SELECTOR = "[data-requirement-icon]"
const STATUS_SELECTOR = "[data-requirement-status]"
const MET_STATUS = "Met"
const UNMET_STATUS = "Not met"

export default class extends Controller {
  static targets = [
    "password",
    "confirmation",
    "lengthRequirement",
    "matchRequirement",
  ]
  static values = { minimumLength: Number, maximumLength: Number }

  connect() {
    this.validate()
  }

  validate() {
    const password = this.passwordTarget.value
    // Ruby counts characters, but JavaScript counts UTF-16 units, so six
    // emoji read as 12 and disagree with the server.
    const characters = [...password]

    this.setRequirement(
      this.lengthRequirementTarget,
      characters.length >= this.minimumLengthValue &&
        characters.length <= this.maximumLengthValue
    )

    if (this.hasMatchRequirementTarget && this.hasConfirmationTarget) {
      this.setRequirement(
        this.matchRequirementTarget,
        characters.length > 0 && password === this.confirmationTarget.value
      )
    }
  }

  setRequirement(requirement, met) {
    const icon = requirement.querySelector(ICON_SELECTOR)

    requirement.classList.toggle(MET_CLASS, met)
    requirement.classList.toggle(UNMET_CLASS, !met)
    icon.classList.remove(...(met ? UNMET_ICON_CLASSES : MET_ICON_CLASSES))
    icon.classList.add(...(met ? MET_ICON_CLASSES : UNMET_ICON_CLASSES))
    requirement.querySelector(STATUS_SELECTOR).textContent = met
      ? MET_STATUS
      : UNMET_STATUS
  }
}
